import { Routes } from '@angular/router';
import { DesignListComponent } from './pages/design-list/design-list.component';
import { DesignDetailComponent } from './pages/design-detail/design-detail.component';
import { DesignFormComponent } from './pages/design-form/design-form.component';
import { RoleGuard } from '../../../core/guards/auth.guard';
import { Permission } from '../../../core/models/role-permissions.models';

export default [
	{
		path: '',
		loadComponent: () => DesignListComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.DESIGN_CONFIG_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'detail/:id',
		loadComponent: () => DesignDetailComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.DESIGN_CONFIG_VIEW],
			comeback: 'design',
		},
	},
	{
		path: 'create',
		loadComponent: () => DesignFormComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.DESIGN_CONFIG_CREATE],
			comeback: 'design',
		},
	},
	{
		path: 'edit/:id',
		loadComponent: () => DesignFormComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.DESIGN_CONFIG_UPDATE],
			comeback: 'design',
		},
	},
] as Routes;
